import React, { useEffect } from 'react';
import "./main.css";
import { HiOutlineLocationMarker, HiOutlineClipboardCheck } from 'react-icons/hi';
import img from '../../Assets/img (1).jpg';
import img2 from '../../Assets/img (2).jpg';
import img3 from '../../Assets/img (3).jpg';
import img4 from '../../Assets/img (4).jpg';
import img5 from '../../Assets/img (5).jpg';
import img6 from '../../Assets/img (6).jpg';
import img7 from '../../Assets/img (7).jpg';
import img8 from '../../Assets/img (8).jpg';
import img9 from '../../Assets/img (9).jpg';

import Aos from "aos";
import 'aos/dist/aos.css';

const Data = [
  {
    id: 1,
    imgSrc: img,
    destTitle: 'ბორა ბორა',
    location: 'ახალი ზელანდია',
    grade: '5 დღე',
    fees: '$700',
    description: 'რომანტიკის განსახიერება, ბორა ბორა არის ერთ-ერთი საუკეთესო სამოგზაურო მიმართულება მსოფლიოში. ეს ადგილი ცნობილია თავისი მდიდრული დასვენების ადგილებით და თავგადასავლებით.'
  },
  {
    id: 2,
    imgSrc: img2,
    destTitle: 'მაჩუ პიკჩუ',
    location: 'პერუ',
    grade: '7 დღე',
    fees: '$600',
    description: 'ჰუაინა პიკჩუ არის მთა პერუში, რომელიც აღემატება მაჩუ პიკჩუს, ინკების დაკარგულ ქალაქს. ეს ადგილი პოპულარულია ტურისტებს შორის.'
  },
  {
    id: 3,
    imgSrc: img3,
    destTitle: 'დიდი ბარიერული რიფი',
    location: 'ავსტრალია',
    grade: '4 დღე',
    fees: '$700',
    description: 'ავსტრალიის ერთ-ერთი ყველაზე მნიშვნელოვანი ბუნებრივი საჩუქარია დიდი ბარიერული რიფი, რომელიც ცნობილია თავისი სილამაზითა და უნიკალურობით.'
  },
  {
    id: 4,
    imgSrc: img4,
    destTitle: 'კაპადოკია',
    location: 'თურქეთი',
    grade: '11 დღე',
    fees: '$800',
    description: 'ყოველწლიურად კაპადოკიას მილიონობით ტურისტი სტუმრობს. ეს ადგილი ცნობილია თავგადასავლებით და საოცარი პეიზაჟებით.'
  },
  {
    id: 5,
    imgSrc: img5,
    destTitle: 'გუანახუატო',
    location: 'მექსიკა',
    grade: '5 დღე',
    fees: '$1100',
    description: 'ცენტრალური მექსიკის ქალაქი, რომელიც ცნობილია ვერცხლის მოპოვების ისტორიით და კოლონიური არქიტექტურით.'
  },
  {
    id: 6,
    imgSrc: img6,
    destTitle: 'ჩინკვე ტერე',
    location: 'იტალია',
    grade: '8 დღე',
    fees: '$840',
    description: 'ეს ადგილი ცნობილია თავისი ფერადი სახლებით და უგემრიელესი ზღვის პროდუქტებით.'
  },
  {
    id: 7,
    imgSrc: img7,
    destTitle: 'ანგკორ ვატი',
    location: 'კამბოჯა',
    grade: '12 დღე',
    fees: '$790',
    description: 'ანგკორ ვატი წარმოადგენს ქჰმერული ხელოვნების მთავარ ნიმუშს, რომელიც წარმოადგენს კამბოჯის გულსა და სულს.'
  },
  {
    id: 8,
    imgSrc: img8,
    destTitle: 'ტაჯ მაჰალი',
    location: 'ინდოეთი',
    grade: '6 დღე',
    fees: '$900',
    description: 'თეთრი მარმარილოს დიდი მაუსოლეუმი, რომელიც აშენდა შაჰ ჯაჰანის მიერ მის მეუღლე მუმთაზის ხსოვნისთვის.'
  },
  {
    id: 9,
    imgSrc: img9,
    destTitle: 'ბალის კუნძული',
    location: 'ინდონეზია',
    grade: '3 დღე',
    fees: '$500',
    description: 'ბალი ცნობილია თავისი ვულკანური მთებით, ისტორიული მემკვიდრეობით, ხელოვნებითა და ულამაზესი პლაჟებით.'
  },
];

export const Main = () => {
  // React hooks for scroll animation
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className='main container section'>
      <div className="secTitle">
        <h3 data-aos="fade-right" className="title">ყველაზე პოპულარული ადგილები</h3>
      </div>

      <div className="secContent grid">
        {Data.map(({ id, imgSrc, destTitle, location, grade, fees, description }) => {
          return (
            <div key={id} data-aos="fade-up" className="singleDestination">
              <div className="imageDiv">
                <img src={imgSrc} alt={destTitle} />
              </div>

              <div className="cardInfo">
                <h4 className="destTitle">{destTitle}</h4>
                <span className="continent flex">
                  <HiOutlineLocationMarker className='icon' />
                  <span className="name">{location}</span>
                </span>

                <div className="fees flex">
                  <div className="grade">
                    <span>{grade}</span>
                  </div>
                  <div className="price">
                    <h5>{fees}</h5>
                  </div>
                </div>

                <div className="desc">
                  <p>{description}</p>
                </div>

                <button className='btn flex'>
                  დეტალები <HiOutlineClipboardCheck className="icon" />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Main;
